
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parlor-places/[id]/flower",
      function () {
        return require("private-next-pages/parlor-places/[id]/flower.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parlor-places/[id]/flower"])
      });
    }
  